
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.205 1.559a.644.644 0 00-.11.06.316.316 0 00-.066.061 1.068 1.068 0 00-.133.136.8.8 0 00-.1.142.751.751 0 00-.07.165A10.81 10.81 0 0120 2.862a10.833 10.833 0 01-4.731-.738.909.909 0 00-.065-.158.787.787 0 00-.1-.148.848.848 0 00-.123-.128l-.077-.072a.793.793 0 00-.125-.065l-.056-.029a.978.978 0 00-.33-.065h-.06a.972.972 0 00-.318.062l-5.008 2a7.955 7.955 0 00-3.68 2.993L.91 13.14a.962.962 0 00-.141.718.972.972 0 00.406.6l6.334 4.222a.953.953 0 001.291-.218l.394-.526v19.657a.955.955 0 00.954.953h19.7a.955.955 0 00.953-.953V17.936l.394.526a.958.958 0 001.292.221l6.333-4.222a.955.955 0 00.265-1.323l-4.412-6.626a7.959 7.959 0 00-3.681-2.988l-5.008-2a.817.817 0 00-.271-.055l-.113-.011a.932.932 0 00-.325.067M20 5.677a5.58 5.58 0 01-3.636-1.222A20.861 20.861 0 0020 4.77a20.861 20.861 0 003.636-.315A5.58 5.58 0 0120 5.677zm-9.55 8.493a.953.953 0 00-1.065.332L7.816 16.6l-4.789-3.2 3.889-5.83A6.046 6.046 0 019.718 5.3l3.917-1.57C14.39 5.979 17.012 7.584 20 7.584s5.61-1.6 6.366-3.854l3.918 1.57a6.058 6.058 0 012.8 2.273l3.891 5.827-4.789 3.2-1.571-2.1a.954.954 0 00-1.717.572v21.567H11.1V15.074a.952.952 0 00-.649-.904z"}})])
          )
        }
      }
    